/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/swiper.styles'
import { DecoriPageConfig } from '../configuration'
import SwiperTicket from './SwiperTicket'
import SwiperTicket2 from './SwiperTicket2'
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Pagination, Navigation } from 'swiper/core'

import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"


import { useMediaQuery } from '@material-ui/core'
import BlockRevealImage from '../BlockRevealImage'
import OnViewPortObserver from '../OnViewPortObserver'
import clsx from 'clsx'
SwiperCore.use([Pagination, Navigation]);

const useStyles = makeStyles(styles)

function SwiperComponent() {
		const ticketSwiperRef = useRef(null)
		const ticketSwiperRef2 = useRef(null)
		const [index, setIndex] = useState(0)
		const [isImageVisible, setImageVisible] = useState(false)
		const [isImageFading, setImageFading] = useState(false)
		const [imageIndex, setImageIndex] = useState(0)
		const isMobile = useMediaQuery('(max-width: 1230px)')
		const slideSwipers = i => {
			if (ticketSwiperRef.current && isMobile) ticketSwiperRef.current.swiper.slideTo(i, 600, false)
		}
		const slideSwipers2 = i => {
			ticketSwiperRef2.current.swiper.slideTo(i, 600, false)
		}
    const changeIndex = index => {
        setImageFading(true)
        slideSwipers(index)
		slideSwipers2(0)
        setIndex(index)
        setTimeout(() => {
            setImageFading(false)
            setImageIndex(index)
        }, 300);
    }
    const classes = useStyles()
    return (
        <div className={classes.root} >
            {!isMobile &&
                <span className={classes.span} >
                    {DecoriPageConfig.patterns.map((e, i) =>
                        <SwiperTicket
                            src={e.src}
                            name={e.name}
                            primaryText={e.firstDimension}
                            secondaryText={e.secondDimension}
                            index={i}
                            bigContent={e.content}
                            key={i}
                            handleClick={changeIndex}
                            open={i === index}
                        />)}
                </span>
            }
            <OnViewPortObserver
                absolute
                y='200px'
                yMobile='300px'
                onEnterViewPort={() => setImageVisible(true)}
            />
			<Swiper
			style={{
					"--swiper-navigation-color": "#FFFFFF",
					"--swiper-pagination-bullet-inactive-color": "#999999",
					"--swiper-pagination-bullet-inactive-opacity": "1",
					"--swiper-pagination-bullet-size": "16px",
					"--swiper-pagination-bullet-horizontal-gap": "6px"
				}}
				modules={[Navigation]}
				direction='horizontal'
				spaceBetween={10}
				watchOverflow= '1'
				slidesPerView='auto'
				navigation={{ clickable: true }}
				ref={ticketSwiperRef2}
				className={classes.mobileTicketSwiper2}>
				{DecoriPageConfig.patternImages[imageIndex].images.map((e, i) =>
					<SwiperSlide
					navigation
					key={i}
					className={classes.ticketSlide2}
					>
						<BlockRevealImage
									imageSrc={e.src}
									blockRevealClass={classes.imageWrap}
									imageClass={clsx(classes.img,classes.swiperImg, isImageFading && classes.fadeImg)}
									isInView={isImageVisible}
									//addShadowOnVisible
									/>
									
					<SwiperTicket2
					src={e.src}
					name={e.name}
					primaryText={e.firstDimension}
					secondaryText={e.secondDimension}
					index={i}
					bigContent={e.content}
					key={i}
					handleClick={changeIndex}
					open="true"
					/>
					</SwiperSlide>
				)}

			</Swiper>
            {isMobile &&
                <Swiper
                    direction='horizontal'
                    spaceBetween={10}
                    ref={ticketSwiperRef}
                    centeredSlides
                    onSlideChange={i => changeIndex(i.realIndex)}
                    slidesPerView='auto'
                    className={classes.mobileTicketSwiper}
                >
                    {DecoriPageConfig.patterns.map((e, i) =>
                        <SwiperSlide
                            key={i}
                            className={classes.ticketSlide}
                        >
                            <SwiperTicket
                                src={e.src}
                                name={e.name}
                                primaryText={e.firstDimension}
                                secondaryText={e.secondDimension}
                                index={i}
                                bigContent={e.content}
                                key={i}
                                handleClick={changeIndex}
                                open={i === index}
                            />
                        </SwiperSlide>
                    )}
                </Swiper>
            }
            {/*<BlockRevealImage
                imageSrc={DecoriPageConfig.patternImages[imageIndex]["first"]}
                blockRevealClass={classes.imageWrap}
                imageClass={clsx(classes.img, isImageFading && classes.fadeImg)}
                isInView={isImageVisible}
                imgAlt='decori'
                addShadowOnVisible
            />
            <BlockRevealImage
                imageSrc={DecoriPageConfig.patternImages[imageIndex]["second"]}
                blockRevealClass={classes.imageWrap}
                imageClass={clsx(classes.img, isImageFading && classes.fadeImg)}
                isInView={isImageVisible}
                imgAlt='decori'
                addShadowOnVisible
            />
            {/* <Swiper
                ref={swiperRef}
                onSlideChange={i => setIndex(i.realIndex)}
                className={classes.swiper}
                spaceBetween={10}
                direction={isMobile ? 'horizontal' : 'vertical'}
                pagination={{
                    "clickable": true
                }}
            >
                {slides}
            </Swiper> */}
        </div>
    )
}

export default memo(SwiperComponent)